import { render, staticRenderFns } from "./listaBajasAcademicas.vue?vue&type=template&id=2c555dc2&"
import script from "./listaBajasAcademicas.vue?vue&type=script&lang=js&"
export * from "./listaBajasAcademicas.vue?vue&type=script&lang=js&"
import style0 from "./listaBajasAcademicas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports